/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { typedFieldValueObjectSchema } from './typedFieldValueObjectSchema';

export const upsertItemFieldValueRequestSchema = z.object({
  get fieldValue() {
    return z.array(typedFieldValueObjectSchema);
  },
});
